// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"50083221","128":"27cfd51d","212":"a563f0a7","368":"e0f7ef64","398":"e8c19a58","472":"22ac1bcd","792":"80d88944","797":"87c2e1ac","844":"58255598","984":"330ce132","993":"76b95dfe"}[chunkId] + ".chunk.js";
};